angular.module('impactx.dialog', []);